export default __webpack_public_path__ + "static/media/company.751f6b5f.svg";